import { NotificationSocketProvider } from '@sit/notifications-client';
import { useToken } from '@web/auth/auth-store';
import { config } from '@web/config/env';

export const ConnectedNotificationSocketProvider = ({ children }: { children: React.ReactNode }) => {
  const token = useToken();
  return (
    <NotificationSocketProvider token={token} notificationsUrl={config.notificationsUrl}>
      {children}
    </NotificationSocketProvider>
  );
};
